import {Dialog, Transition} from "@headlessui/react";
import {Fragment} from "preact";
import s from "./nadBeneficiaryModal.module.css";
import {useNadBeneficiaryModal} from "./useNadBeneficiaryModal";

const NadBeneficiaryModal = (props) => {
    // Destructured props
    const {
        isModalOpen,
        handleBannerClick,
        source = "default",
        setSameBeneficiaryModalOpen = () => {},
        handleBeneficiarySkip = () => {},
    } = props;

    // Component logic data
    const componentProps = useNadBeneficiaryModal({
        source,
        setSameBeneficiaryModalOpen,
        handleBeneficiarySkip
    });

    // Destructured component logic data
    const {handleActionClick} = componentProps;

    return (
        <Fragment>
            <Transition.Root show={isModalOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[20]" onClose={handleBannerClick}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-fade-modal bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full px-4 md:px-0 items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className={`font-museo relative transform overflow-hidden bg-light-gray rounded-2xl border border-black py-14 px-6 md:px-12 text-left shadow-xl duration-700 sm:max-w-[608px] w-screen flex items-start md:items-center`}>
                                    <div className={"flex w-full flex-col gap-y-12"}>
                                        <h1 className={`${s.title}`}>
                                            O pedido é pra você?
                                        </h1>
                                        <div className={`${s.buttonsContainer}`}>
                                            <button
                                                type={"button"}
                                                className={`${s.button} ${s.noButton}`}
                                                onClick={() => handleActionClick({
                                                    action: "no"
                                                })}
                                            >
                                                Não
                                            </button>
                                            <button
                                                type={"button"}
                                                className={`${s.button} ${s.yesButton}`}
                                                onClick={() => handleActionClick({
                                                    action: "yes"
                                                })}
                                            >
                                                Sim
                                            </button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default NadBeneficiaryModal;
